import React, {
  memo, useCallback, useMemo, useRef,
} from 'react';
import {
  Box, IconButton, makeStyles, styled, useMediaQuery, withStyles,
} from '@material-ui/core';
import { chunk as lodashChunk } from 'lodash';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

const TAB_MAP = {
  HOT_PRE_ORDER: 'HOT_PRE_ORDER',
  CLOSED_PRE_ORDER: 'CLOSED_PRE_ORDER',
};

export const PAGING_BUTTON_ACTION_MAP = {
  BACK: 'BACK',
  FORWARD: 'FORWARD',
};

const useSliderStyle = makeStyles((theme) => ({ root: { '&+&': { marginTop: theme.spacing(4) } } }));

const SliderContiner = withStyles({ root: { '&::-webkit-scrollbar': { display: 'none' } } })(Box);

export const StyledLink = styled(Link)({
  color: 'black !important',
  textDecoration: 'underline !important',
});

const StyledSliderItem = withStyles((theme) => ({ root: { '&+&': { marginLeft: theme.spacing(2) } } }))(Box);

export const SliderItem = ({ chunk = 1, restOfProps, children }) => (
  <StyledSliderItem
    {...restOfProps}
    width={`calc(${100 / chunk}% - ${(16 * (chunk - 1)) / chunk}px)`}
  >
    {children}
  </StyledSliderItem>
);

export default memo(({
  chunk: propsChunk,
  data,
  onCategoryLinkClick,
  renderItem,
  showCategoryLink = true,
  title,
}) => {
  const classes = useSliderStyle();
  const containerRef = useRef(undefined);
  const isMD = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const isSM = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  // eslint-disable-next-line no-nested-ternary
  const chunk = propsChunk || (isMD ? 3 : (isSM ? 2 : 1));
  const dataToRender = useMemo(() => lodashChunk(data, chunk), [chunk, data]);
  const pagingButtonClick = useCallback((type) => () => {
    const { scrollLeft, offsetWidth } = containerRef.current;
    containerRef.current.scrollTo({
      behavior: 'smooth',
      left: type === PAGING_BUTTON_ACTION_MAP.BACK
        ? scrollLeft - offsetWidth
        : scrollLeft + offsetWidth,
    });
  }, []);

  return (
    <Box
      className={classes.root}
      display="flex"
      flexDirection="column"
      alignItems="stretch"
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="end">
          <Box fontSize={16} fontWeight="bold">{title}</Box>
          {showCategoryLink
          && (
          <Box ml={1}>
            <StyledLink to={`/pre-orders?activeNav=${TAB_MAP.HOT_PRE_ORDER}-${title}`} onClick={onCategoryLinkClick}>
              逛逛此分類
              {'>'}
            </StyledLink>
          </Box>
          )}
        </Box>
        {dataToRender.flat().length > chunk
        && (
        <Box>
          <IconButton
            style={{ backgroundColor: '#f5f5f5', width: 24, height: 24 }}
            onClick={pagingButtonClick(PAGING_BUTTON_ACTION_MAP.BACK)}
          >
            <ArrowBackIcon style={{ fontSize: 16 }} />
          </IconButton>
          <IconButton
            style={{
              marginLeft: 16,
              backgroundColor: '#f5f5f5',
              width: 24,
              height: 24,
            }}
            onClick={pagingButtonClick(PAGING_BUTTON_ACTION_MAP.FORWARD)}
          >
            <ArrowForwardIcon style={{ fontSize: 16 }} />
          </IconButton>
        </Box>
        )}
      </Box>
      <SliderContiner
        display="flex"
        ref={containerRef}
        style={{
          overflowX: 'scroll',
          scrollSnapType: 'x mandatory',
        }}
      >
        {
          (dataToRender || []).map((dataChunk, index) => (
            <Box
              display="flex"
              flexBasis="100%"
              flexGrow={1}
              flexShrink={0}
              p={1}
              width={1}
              // eslint-disable-next-line react/no-array-index-key
              key={`slider-${index}`}
              style={{ scrollSnapAlign: 'start' }}
            >
              {
                (dataChunk || []).map((dataItem) => {
                  const { id } = dataItem || {};

                  return (
                    <SliderItem key={id} chunk={chunk}>
                      <LazyLoadComponent>
                        {renderItem(dataItem)}
                      </LazyLoadComponent>
                    </SliderItem>
                  );
                })
              }
            </Box>
          ))
        }
      </SliderContiner>
    </Box>
  );
});
